<!-- StatisticsView.vue -->
<template>
    <div class="card box_component">
        <h5 class="card-header">{{ $t('judging_program.statistics.card_header') }}</h5>
        <div class="card-body">
            <div class="container text-center">
                <div class="row">
                    <div class="col-12 col-sm-6 py-2">
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(1)">
                                {{ $t('judging_program.statistics.total_1') }}:
                                <span class="badge bg-secondary rounded-pill">
                                    {{ this.counts().tricks.variations.total.FS ? this.counts().tricks.variations.total.FS : 0 }}
                                </span>
                            </li>
                            <div v-if="collapsedStates[1]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="trickId in this.counts().tricks.variations.details.FS" :key="trickId" class="list-group-item condense-item">
                                        {{ trickId }}
                                    </li>
                                </ul>
                            </div>
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(2)">
                                {{ $t('judging_program.statistics.total_2') }}:
                                <span class="badge bg-secondary rounded-pill">
                                    {{ this.counts().tricks.variations.total.BS ? this.counts().tricks.variations.total.BS : 0 }}
                                </span>
                            </li>
                            <div v-if="collapsedStates[2]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="trickId in this.counts().tricks.variations.details.BS" :key="trickId" class="list-group-item condense-item">
                                        {{ trickId }}
                                    </li>
                                </ul>
                            </div>
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(3)">
                                {{ $t('judging_program.statistics.total_3') }}:
                                <span class="badge bg-secondary rounded-pill">
                                    {{ this.counts().tricks.grabs.total ? this.counts().tricks.grabs.total : 0 }}
                                </span>
                            </li>
                            <div v-if="collapsedStates[3]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="trickId in this.counts().tricks.grabs.details" :key="trickId" class="list-group-item condense-item">
                                        {{ trickId }}
                                    </li>
                                </ul>
                            </div>
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(4)">
                                {{ $t('judging_program.statistics.total_4') }}:
                                <span class="badge bg-secondary rounded-pill">
                                    {{ this.counts().tricks.dubs.total ? this.counts().tricks.dubs.total : 0 }}
                                </span>
                            </li>
                            <div v-if="collapsedStates[4]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="trickId in this.counts().tricks.dubs.details" :key="trickId" class="list-group-item condense-item">
                                        {{ trickId }}
                                    </li>
                                </ul>
                            </div>
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(5)">
                                {{ $t('judging_program.statistics.total_5') }}:
                                <span class="badge bg-secondary rounded-pill">
                                    {{ this.counts().tricks.unique.total ? this.counts().tricks.unique.total : 0 }}
                                </span>
                            </li>
                            <div v-if="collapsedStates[5]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="trickId in this.counts().tricks.unique.details" :key="trickId" class="list-group-item condense-item">
                                        {{ trickId }}
                                    </li>
                                </ul>
                            </div>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-6 py-2">
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(6)">
                                {{ $t('judging_program.statistics.total_6') }}:
                                <span class="badge bg-secondary rounded-pill">{{ this.counts().tricks.totals.total ? this.counts().tricks.totals.total : 0 }}</span>
                            </li>
                            <div v-if="collapsedStates[6]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="trickId in this.counts().tricks.totals.details" :key="trickId" class="list-group-item condense-item">
                                        {{ trickId }}
                                    </li>
                                </ul>
                             </div>
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(7)">
                                {{ $t('judging_program.statistics.total_7') }}:
                                <span class="badge bg-secondary rounded-pill">{{ this.counts().combos.normal.total ? this.counts().combos.normal.total : 0 }}</span>
                            </li>
                            <div v-if="collapsedStates[7]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="(index, trickId) in Object.keys(this.counts().combos.normal.details)" :key="trickId" class="list-group-item condense-item">
                                        {{ getComboNameById(index) }}
                                    </li>
                                </ul>
                            </div>
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(8)">
                                {{ $t('judging_program.statistics.total_8') }}:
                                <span class="badge bg-secondary rounded-pill">{{ this.counts().combos.longer.total ? this.counts().combos.longer.total : 0 }}</span>
                            </li>
                            <div v-if="collapsedStates[8]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="(index, trickId) in Object.keys(this.counts().combos.longer.details)" :key="trickId" class="list-group-item condense-item">
                                        {{ getComboNameById(index) }}
                                    </li>
                                </ul>
                            </div>
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(9)">
                                {{ $t('judging_program.statistics.total_9') }}:
                                <span class="badge bg-secondary rounded-pill">{{ this.counts().combos.normal_to_feet.total ? this.counts().combos.normal_to_feet.total : 0 }}</span>
                            </li>
                            <div v-if="collapsedStates[9]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="(index, trickId) in Object.keys(this.counts().combos.normal_to_feet.details)" :key="trickId" class="list-group-item condense-item">
                                        {{ getComboNameById(index) }}
                                    </li>
                                </ul>
                            </div>
                            <li class="list-group-item d-flex justify-content-between align-items-center" @click="toggleCollapse(10)">
                                {{ $t('judging_program.statistics.total_10') }}:
                                <span class="badge bg-secondary rounded-pill">{{ this.counts().combos.longer_to_feet.total ? this.counts().combos.longer_to_feet.total : 0 }}</span>
                            </li>
                            <div v-if="collapsedStates[10]">
                                <ul class="list-group small-font condense-list" style="max-height: 150px; overflow-y: auto;">
                                    <li v-for="(index, trickId) in Object.keys(this.counts().combos.longer_to_feet.details)" :key="trickId" class="list-group-item condense-item">
                                        {{ getComboNameById(index) }}
                                    </li>
                                </ul>
                            </div>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 py-2 d-flex justify-content-between align-items-center">
                        <canvas id="circleChart" class="circleChart" width="400" height="200"></canvas>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 py-2 d-flex justify-content-between align-items-center">
                        <canvas id="barChart" class="barChart"  width="400" height="200"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js/auto';
import { secureStorage } from "@/services/secureStorage";

export default {
    name: "StatisticsTricks",
    data() {
        return {
            collapsedStates: [],
            circleChart : null,
            barChart  : null,
            validatedTricks: JSON.parse(secureStorage.getItem('validatedTricks')) || [],
        };
    },
    mounted() {
        this.counts();
        this.createCircleChart();
        this.createBarChart();
    },
    methods: {
        counts() {
            const tricks = {
                unique : this.countUniqueTrick(),
                grabs : this.countTrickPropertyDeep('grab'),
                dubs : this.countTrickPropertyDeep('dub'),
                variations : this.countVariation('variation'),
                levels : this.countTrickPropertyGraphCircle('level'),
                categories : this.countTrickPropertyGraphBar('category'),
                totals : this.countTotalTrick(),
            };
            const combos = {
                unique : this.countUniqueCombo(),
                normal : this.countNormalCombo(),
                normal_to_feet : this.countNormalToFeetCombo(),
                longer : this.countLongerCombo(),
                longer_to_feet : this.countLongerToFeetCombo(),
                totals : this.countTotalCombo(),
            };
            return {
                tricks: tricks,
                combos: combos,
            };
        },
        /*Counters Tricks*/
        countUniqueTrick() {
            const result = {
                total: 0,
                counter: [],
                details: []
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    const key = this.getKeyForTrick(trick);
                    if (key !== undefined) {
                        if (result.counter.find(existingKey => existingKey === key) === undefined) {
                            result.counter.push(key);
                            const name = this.getNameForTrick(trick);
                            result.details.push(name);
                            result.total = (result.total || 0) + 1;
                        }
                    }
                    if (Array.isArray(trick.body)) {
                        countTricks(trick.body);
                    }
                });
            };
            countTricks(this.validatedTricks);
            // totalReturn.total = trickCounts.size;
            return result;
        },
        countTotalTrick() {
            const result = {
                total: 0,
                details: []
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    const key = this.getKeyForTrick(trick);
                    if (key !== undefined) {
                        const name = this.getNameForTrick(trick);
                        result.details.push(name);
                        result.total = (result.total || 0) + 1;
                    }

                    if (Array.isArray(trick.body)) {
                        countTricks(trick.body);
                    }
                });


            };
            countTricks(this.validatedTricks);
            return result;
        },
        countTrickPropertyDeep(property) {
            const result = {
                total: 0,
                details: []
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body)) {
                        countTricks(trick.body);
                    }else{
                        if (trick[property] !== undefined && trick[property] > 0) {
                            const key = this.getNameForTrick(trick);
                            if (key !== undefined) {
                                result.details.push(key);
                            }
                            result.total = (result.total || 0) + 1;
                            /*result.details[value] = result.details[value] || [];
                            result.details[value].push(trick.id);*/
                        }
                    }
                });
            };
            countTricks(this.validatedTricks);
            return result;
        },
        countTrickPropertyGraphCircle(property) {
            let countLevel = [];
            let countChartLevel = [0, 0, 0, 0];
            const result = {
                total: {},
                details: {}
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body)) {
                        countTricks(trick.body);
                    }else{
                        if (trick[property] !== undefined && trick[property] > 0) {
                            const value = trick[property];
                            countChartLevel[trick.level - 1] = (countChartLevel[trick.level - 1] || 0) + 1;
                            countLevel[trick.level] = (countLevel[trick.level] || 0) + 1;
                            result.total = (result.total[value] || 0) + 1;
                            result.details[value] = result.details[value] || [];
                            result.details[value].push(trick.id);
                        }
                    }
                });
            };

            countTricks(this.validatedTricks);
            result.total = countChartLevel;
            return result;
        },
        countTrickPropertyGraphBar(property) {
            let countCategory = [];
            let countChartCategory = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            const result = {
                total: {},
                details: {}
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body)) {
                        countTricks(trick.body);
                    }else{
                        if (trick[property] !== undefined && trick[property] > 0) {
                            const value = trick[property];
                            countChartCategory[trick.level - 1] = (countChartCategory[trick.level - 1] || 0) + 1;
                            countCategory[trick.level] = (countCategory[trick.level] || 0) + 1;
                            result.total = (result.total[value] || 0) + 1;
                            result.details[value] = result.details[value] || [];
                            result.details[value].push(trick.id);
                        }
                    }
                });
            };

            countTricks(this.validatedTricks);
            result.total = countChartCategory;
            return result;
        },
        countVariation(property) {
            const result = {
                total: {
                    '0': 0,
                    'FS': 0,
                    'BS': 0
                },
                details: {
                    '0': [],
                    'FS': [],
                    'BS': []
                }
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body)) {
                        countTricks(trick.body);
                    }else{
                        if (trick[property] !== undefined) {
                            let variation = 0;
                            switch (true) {
                                case trick[property] === 1:
                                    variation = `FS`;
                                    break;
                                case trick[property] === 2:
                                    variation = `BS`;
                                    break;
                                default:
                                    break;
                            }
                            const key = this.getNameForTrick(trick);
                            if (key !== undefined) {
                                result.details[variation].push(key);
                            }
                            result.total[variation]++;
                        }
                    }
                });
            };
            countTricks(this.validatedTricks);
            return result;
        },
        /*Counters Combos*/
        countUniqueCombo() {
            const comboCounts = new Map();
            const comboDetails = {};
            let countCombo = 0;
            const existingCombos = new Set(); // Nuevo conjunto para rastrear conjuntos existentes
            const totalReturn = {
                'details': comboDetails,
                'total': 0
            };
            const countCombos = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body)) {
                        const subComboCounts = new Set();
                        const subComboDetails = {};

                        trick.body.forEach(subTrick => {
                            const subKey = this.getKeyForTrick(subTrick);

                            if (subKey !== undefined) {
                                // Utilizando Set para evitar duplicados
                                subComboCounts.add(subKey);

                                if (subTrick.combo_id !== undefined) {
                                    const subComboId = subTrick.combo_id;

                                    if (!subComboDetails[subComboId]) {
                                        subComboDetails[subComboId] = new Set();
                                    }

                                    subComboDetails[subComboId].add(subKey);
                                }
                            }
                        });

                        if (subComboCounts.size > 1) {
                            // Verificar si el conjunto ya existe antes de agregarlo
                            const comboArray = Array.from(subComboCounts);
                            const comboString = comboArray.sort().toString();

                            if (!existingCombos.has(comboString)) {
                                existingCombos.add(comboString);
                                subComboCounts.forEach(key => {
                                    comboCounts.set(key, (comboCounts.get(key) || 0) + 1);
                                });
                                countCombo++;
                                Object.assign(comboDetails, subComboDetails);
                            }
                        }
                    }
                });
            };

            countCombos(this.validatedTricks);

            totalReturn.total = countCombo;

            return totalReturn;
        },
        countNormalCombo() {
            const comboDetails = {};
            let countCombo = 0;
            const totalReturn = {
                'details': comboDetails,
                'total': 0
            };
            const countCombos = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body) && trick.body.length >= 2 && trick.body.length <= 5) {
                        const lastSubTrick = trick.body[trick.body.length - 1];

                        if (lastSubTrick && lastSubTrick.type !== 1) {
                            trick.body.forEach(subTrick => {
                                const subKey = this.getKeyForTrick(subTrick);

                                if (subKey !== undefined) {
                                    if (!comboDetails[subTrick.combo_id]) {
                                        comboDetails[subTrick.combo_id] = new Set();
                                    }
                                    comboDetails[subTrick.combo_id].add(subKey);
                                }
                            });

                            countCombo++;
                        }
                    }
                });
            };
            countCombos(this.validatedTricks);
            totalReturn.total = countCombo;
            return totalReturn;
        },
        countNormalToFeetCombo() {
            const comboDetails = {};
            let countCombo = 0;
            const totalReturn = {
                'details': comboDetails,
                'total': 0
            };

            const countCombos = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body) && trick.body.length >= 2 && trick.body.length <= 5) {
                        const lastSubTrick = trick.body[trick.body.length - 1];

                        if (lastSubTrick && lastSubTrick.type === 1) {
                            trick.body.forEach(subTrick => {
                                const subKey = this.getKeyForTrick(subTrick);

                                if (subKey !== undefined) {
                                    if (!comboDetails[subTrick.combo_id]) {
                                        comboDetails[subTrick.combo_id] = new Set();
                                    }
                                    comboDetails[subTrick.combo_id].add(subKey);
                                }
                            });

                            countCombo++;
                        }
                    }
                });
            };

            countCombos(this.validatedTricks);

            // Calcular el total de combos que cumplen con la condición
            totalReturn.total = countCombo;

            return totalReturn;
        },
        countLongerCombo() {
            const comboDetails = {};
            let countCombo = 0;
            const totalReturn = {
                'details': comboDetails,
                'total': 0
            };
            const countCombos = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body) && trick.body.length >= 6) {
                        const lastSubTrick = trick.body[trick.body.length - 1];

                        if (lastSubTrick && lastSubTrick.type !== 1) {
                            trick.body.forEach(subTrick => {
                                const subKey = this.getKeyForTrick(subTrick);

                                if (subKey !== undefined) {
                                    if (!comboDetails[subTrick.combo_id]) {
                                        comboDetails[subTrick.combo_id] = new Set();
                                    }
                                    comboDetails[subTrick.combo_id].add(subKey);
                                }
                            });

                            countCombo++;
                        }
                    }
                });
            };
            countCombos(this.validatedTricks);
            totalReturn.total = countCombo;
            return totalReturn;
        },
        countLongerToFeetCombo() {
            const comboDetails = {};
            let countCombo = 0;
            const totalReturn = {
                'details': comboDetails,
                'total': 0
            };

            const countCombos = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body) && trick.body.length >= 6) {
                        const lastSubTrick = trick.body[trick.body.length - 1];

                        if (lastSubTrick && lastSubTrick.type === 1) {
                            trick.body.forEach(subTrick => {
                                const subKey = this.getKeyForTrick(subTrick);

                                if (subKey !== undefined) {
                                    if (!comboDetails[subTrick.combo_id]) {
                                        comboDetails[subTrick.combo_id] = new Set();
                                    }
                                    comboDetails[subTrick.combo_id].add(subKey);
                                }
                            });

                            countCombo++;
                        }
                    }
                });
            };

            countCombos(this.validatedTricks);

            // Calcular el total de combos que cumplen con la condición
            totalReturn.total = countCombo;

            return totalReturn;
        },
        countTotalCombo() {
            const comboDetails = new Map();
            const totalReturn = {
                'details': comboDetails,
                'total': 0
            };
            const countTricks = (tricks) => {
                tricks.forEach(trick => {
                    if (Array.isArray(trick.body)) {
                        const comboId = trick.header.combo_id;
                        if (comboId !== undefined) {
                            if (!comboDetails.has(comboId)) {
                                comboDetails.set(comboId, []);
                                totalReturn.total++;
                            }
                            comboDetails.get(comboId).push(...trick.body.map(subTrick => subTrick.id));
                        }

                        countTricks(trick.body);
                    }
                });
            };
            countTricks(this.validatedTricks);
            return totalReturn;
        },
        /*Utils for Counters*/
        getKeyForTrick(trick) {
            if (trick.id !== undefined) {
                return trick.id + (trick.variation ? ` - ${trick.variation}` : '') + (trick.grab ? ` - ${trick.grab}` : '');
            } else {
                return undefined;
            }
        },
        getNameForTrick(trick) {
            if (trick.id !== undefined) {
                let truncatedName = trick.name.substring(0, 12);

                if (trick.name.length > 12) {
                    truncatedName += '...';
                }

                let result = truncatedName;

                if (trick.variation && trick.variation !== '0') {
                    switch (true) {
                        case trick.variation === 1:
                            result += ` FS `;
                            break;
                        case trick.variation === 2:
                            result += ` BS `;
                            break;
                        default:
                            break;
                    }
                }

                if (trick.grab) {
                    result += ` | G`;
                }
                if (trick.dub) {
                    switch (true) {
                        case trick.dub === 1:
                            result += ` | 20%`;
                            break;
                        case trick.dub === 2:
                            result += ` | 50%`;
                            break;
                        case trick.dub === 3:
                            result += ` | 80%`;
                            break;
                        default:
                            break;
                    }
                }

                return result;
            } else {
                return undefined;
            }
        },
        category_name() {
            return [
                { id: 1, name: 'Aerial'},
                { id: 2, name: 'Aerial / Flip'},
                { id: 3, name: 'Aerial / Switch'},
                { id: 4, name: 'Dynamic'},
                { id: 5, name: 'Dynamic / Flip'},
                { id: 6, name: 'Dynamic / Flip / Switch '},
                { id: 7, name: 'Dynamic / Switch'},
                { id: 8, name: 'Dynamic / Transition'},
                { id: 9, name: 'Mount'},
                { id: 10, name: 'Static'},
                { id: 11, name: 'Transition'},
            ];
        },
        level_name() {
            return [
                { id: 1, name: 'ROOKY'},
                { id: 2, name: 'AMATEUR'},
                { id: 3, name: 'PRO'},
                { id: 4, name: 'LEGENDARY'},
            ];
        },
        toggleCollapse(tab_id) {
            this.collapsedStates[tab_id] = !this.collapsedStates[tab_id];
        },
        getComboNameById(trickId) {
            return trickId ? 'Combo Nª '+trickId : 'Combo no encontrado';
        },
        createCircleChart() {
            const canvas = document.getElementById('circleChart');
            if (!canvas) {
                console.error("Canvas 'barChart' not found.");
                return;
            }
            const ctx = canvas.getContext('2d');
            const levelNames = this.level_name().map(level => {
                return level.name;
            });
            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: levelNames,
                    datasets: [{
                        data: this.counts().tricks.levels.total,
                        backgroundColor: [
                            'rgb(8,76,255)',
                            'rgb(23,231,0)',
                            'rgb(255,126,0)',
                            'rgb(255,0,0)'
                        ],
                        borderColor: [
                            'rgb(8,76,255)',
                            'rgb(23,231,0)',
                            'rgb(255,126,0)',
                            'rgb(255,0,0)'
                        ],
                        borderWidth: 0
                    }]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    responsive: true, // Desactiva la responsividad
                    maintainAspectRatio: true, // Desactiva el mantenimiento del aspecto
                    cutout: '25%', // A
                    plugins: {
                        legend: {
                            display: true,
                            position: 'bottom' // Puedes ajustar la posición de la leyenda según tus necesidades
                        }
                    }
                }
            });
        },
        createBarChart() {
            const canvas = document.getElementById('barChart');
            if (!canvas) {
                console.error("Canvas 'barChart' not found.");
                return;
            }
            const ctx = canvas.getContext('2d');
            const categoryNames = this.category_name().map(category => {
                return category.name;
            });
            new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: categoryNames,
                    datasets: [{
                        label: 'Category',
                        data: this.counts().tricks.categories.total,
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        borderColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 1
                    }]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    responsive: true, // Desactiva la responsividad
                    maintainAspectRatio: true, // Desactiva el mantenimiento del aspecto
                    cutout: '75%', // A
                }
            });
        },
    },
    watch: {
        validatedTricks() {
            this.counts();
        },
    },
};
</script>

<style scoped>
.box_component {
    width: 100%;
    max-width: 100%;
    margin: 15px auto;
}
.small-font {
    font-size: 0.8rem;
}
.condense-list {
    line-height: 1.2;
}
.condense-item {
    padding: 0.25rem 0.5rem;
    text-align: left;
}
@media (min-width: 601px) {

}
</style>
